import LeMagArticle from "../LeMagArticle";
import { VirtualController } from "../VirtualController";
import {
  AddonOption,
  Device,
  Game,
  GameController,
  GameStatus,
  PEGIRating,
} from "../Game";
import { List } from "../List";
import { Video } from "../Video";

export class MockGame implements Game {
  private static INDEX = 0;

  public id: string;
  public images = [];
  public videos: Video[] = [];
  public mainAdjectives = [];
  public name = "name";
  public slug = "slug";
  public controllers?: GameController[];
  public descriptionHtml?: string | undefined;
  public developer?: { id: string; name: string } | undefined;
  public esrbDescriptors?: { id: string; label: string }[] | undefined;
  public esrbRating?: { id: string; label: string } | undefined;
  public genres?: { id: string; title: string; uuid: string }[] | undefined;
  public lifetime?: number | undefined;
  public maxGamepad?: number | undefined;
  public pegiDescriptors?: { id: string; label: string }[] | undefined;
  public pegiRating?: PEGIRating;
  public publisher?: { id: string; name: string } | undefined;
  public blacknutRating?: PEGIRating | undefined;
  public recommendations?: List[] | undefined;
  public sessionDuration?: string | undefined;
  public useMapping?: boolean | undefined;
  public socialModes?: { id: string; label: string }[] | undefined;
  public descriptionTitle?: string | undefined;
  public devices?: Device[] | undefined;
  public multiPlayer?: boolean | undefined;
  public online?: boolean | undefined;
  public gamepadToMouse?: boolean | undefined;
  public remoteToMouse?: boolean | undefined;
  public freeText?: string | undefined;
  public virtualControllers?: VirtualController[] | undefined;
  public status?: GameStatus | undefined;
  public videoHeight?: number | undefined;
  public videoWidth?: number | undefined;
  public newGame?: boolean | undefined;
  public genre = "string";
  public createdAt = "createdAt";
  public lemag?: LeMagArticle[] | undefined;
  public addonOption?: AddonOption | undefined;

  constructor() {
    MockGame.INDEX++;
    this.id = `${MockGame.INDEX}`;
  }
}
export class MockGameAddonOption implements AddonOption {
  public bonusGameAddedAt = "Date";
  public isAvailableForCurrentUser = false;
  public isBonusGame = false;
  public inGamePass = false;
  public bonusGameUser?:
    | { avatarID?: string | undefined; isMaster: boolean; nickname: string }
    | undefined;
  public bonusGameDaysLeft = 3;
  public isUbisoftProduct = undefined;
  public userHasGamePass = false;
}
